import React from 'react';


const LanguageItem = ({language, switchLanguage, handleRequestClose}) => {
  const {icon, name} = language;
  return (
    <li className="pointer" onClick={() => {
    //  //console.log("*************************************************** language ",language , JSON.stringify(language))
      handleRequestClose();
      switchLanguage(language);
      localStorage.setItem("language",JSON.stringify(language));
    }}>
      <div className="d-flex align-items-center">
        <i className={`flag flag-24 flag-${icon}`}  style={{ backgroundImage: `url(${require("assets/images/flag.png").default})` }} />
        <h4 className="mb-0 ml-2">{name}</h4>
      </div>
    </li>
  );
};

export default LanguageItem;
